//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapMutations} from "vuex";
import {analysis} from "@/constants";
import FieldAnalysis from "./FieldAnalysis";

export default {
  name: "ChoosePredictionsStep",
  components: {
    FieldAnalysis
  },

  data() {
    return {
      search: null,
      loading: true,
      expand: {},
      properties: [],
      searched: [],
      statistics: []
    };
  },

  watch: {
    statistics() {
      this.searched = this.overrideStatisticsTypes(this.statistics);
    }
  },

  computed: {
    ...mapGetters(["newModel"])
  },

  methods: {
    ...mapMutations({
      setNewModel: "setNewModel",
      setShowFieldEdit: "setShowFieldEdit",
      editFieldData: "editFieldData"
    }),

    expandCell(obj) {
      if (this.expand[obj.field] === undefined || !this.expand[obj.field]) {
        this.$set(this.expand, obj.field, true);
      } else {
        this.$set(this.expand, obj.field, false);
      }
    },

    editField(item) {
      this.editFieldData(item);
      this.setShowFieldEdit(true);
    },

    updatePredictionProperties(selection) {
      const tmpModel = Object.assign({}, this.newModel);
      tmpModel.selectedPredictionProperties = selection;
      this.setNewModel(tmpModel);
    },

    searchOnTable() {
      this.searched = this.searchByName(this.overrideStatisticsTypes(this.statistics), this.search);
    },

    searchByName(items, term) {
      if (term) {
        return items.filter(item =>
            this.toLower(item.field).includes(this.toLower(term))
        );
      }
      this.searched = this.overrideStatisticsTypes(this.statistics);
      return this.searched;
    },

    // override all types as "Category" based on what is supported
    overrideStatisticsTypes(statistics) {
      return statistics.map(stat => ({
        ...stat,
        type: 'cat'
      }));
    },

    toLower(term) {
      return term.toString().toLowerCase();
    },

    dotClass(severity) {
      switch (severity) {
        case analysis.FATAL:
          return "red";
        case analysis.WARNING:
          return "orange";
        case analysis.NONE:
          return "green";
        default:
          break;
      }
    }
  }
};
